<template>
  <div class="w-100">
    Job CREATED
    <job-object :job-number="activity.job_id" />

    <ul v-if="$lodash.has(activity.detail, 'job')" class="pl-0">
      <li v-if="$lodash.has(activity.detail.job, 'service_types')">
        <generic-object>Service Types</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large cursor">
          <div
            v-tooltip="{
              content: serviceTypes,
              classes: ['badge-theme'],
            }"
            class="d-inline-block"
          >
            ... ...
          </div>
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'customer')">
        <generic-object>Customer</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large">
          {{ activity.detail.job.customer.name }}
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'contacts')">
        <generic-object>Contacts</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large cursor">
          <div
            v-tooltip="{
              content: contacts,
              classes: ['badge-theme'],
            }"
            class="d-inline-block"
          >
            ... ...
          </div>
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'address.job_address')">
        <generic-object>Job Address</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large cursor">
          <div
            v-tooltip="{
              content: activity.detail.job.address.job_address.formatted,
              classes: ['badge-theme'],
            }"
            class="d-inline-block"
          >
            ... ...
          </div>
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'address.billing_address')">
        <generic-object>Billing Address</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large cursor">
          <div
            v-tooltip="{
              content: activity.detail.job.address.billing_address.formatted,
              classes: ['badge-theme'],
            }"
            class="d-inline-block"
          >
            ... ...
          </div>
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'po_reference')">
        <generic-object>Po Reference</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large">
          {{ activity.detail.job.po_reference }}
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'description')">
        <generic-object>Description</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large cursor">
          <div
            v-tooltip="{
              content: activity.detail.job.description,
              classes: ['badge-theme'],
            }"
            class="d-inline-block"
          >
            ... ...
          </div>
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'found_via')">
        <generic-object>Found Via</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large">
          {{ activity.detail.job.found_via }}
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'status')">
        <generic-object>Status</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large">
          {{ activity.detail.job.status }}
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'referred_by')">
        <generic-object>Referred By</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large">
          {{ activity.detail.job.referred_by.name }}
        </div>
      </li>

      <li v-if="$lodash.has(activity.detail.job, 'is_recurring')">
        <generic-object>Recurring</generic-object>
        <div class="d-inline-block px-1">set to</div>
        <div class="badge rounded-pill bg-primary badge-large">
          {{ activity.detail.job.is_recurring === 1 ? "Yes" : "No" }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  computed: {
    serviceTypes() {
      return this.$lodash.get(this.activity.detail, "job.service_types.new", []).join(", ");
    },

    contacts() {
      const contacts = [];
      if (this.$lodash.has(this.activity.detail, 'job.contacts["Job Contact"]')) {
        contacts.push(
          `<b>Job Contact:</b> ${this.activity.detail.job.contacts["Job Contact"].name}`
        );
      }

      this.$lodash.each(this.activity.detail.job.contacts, (contact, role) => {
        if (role !== "Job Contact") {
          contacts.push(`<b>${role}:</b> ${contact.name}`);
        }
      });

      return contacts.join("<br>");
    },
  },
};
</script>

<style scoped>
ul {
  list-style: none;
}

li {
  padding-top: 2px;
  padding-bottom: 2px;
}

pre {
  display: inline-block;
}
</style>
